import React from 'react';
import { FaShuttleVan, FaTableTennis, FaBirthdayCake } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// SVG Icons for each service
const TeamIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#5ec6fd" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
  </svg>
);

const Services = () => {
  const { t } = useTranslation();

  const servicesData = [
    {
      icon: <FaBirthdayCake size={48} color="#5ec6fd" />,
      title: t('services.cards.events.title'),
      subtitle: t('services.cards.events.subtitle'),
      description: t('services.cards.events.description'),
      buttonText: t('services.cards.events.buttonText'),
      buttonLink: "/packages",
    },
    {
      icon: <TeamIcon />,
      title: t('services.cards.teambuilding.title'),
      subtitle: t('services.cards.teambuilding.subtitle'),
      description: t('services.cards.teambuilding.description'),
      buttonText: t('services.cards.teambuilding.buttonText'),
      buttonLink: "/teambuilding",
    },
    {
      icon: <FaShuttleVan size={48} color="#5ec6fd" />,
      title: t('services.cards.allInclusive.title'),
      subtitle: t('services.cards.allInclusive.subtitle'),
      description: t('services.cards.allInclusive.description'),
      buttonText: t('services.cards.allInclusive.buttonText'),
      buttonLink: "/transfers",
    },
    {
      icon: <FaTableTennis size={48} color="#5ec6fd" />,
      title: t('services.cards.lessons.title'),
      subtitle: t('services.cards.lessons.subtitle'),
      description: t('services.cards.lessons.description'),
      buttonText: t('services.cards.lessons.buttonText'),
      buttonLink: "/lessons",
    },
  ];

  return (
    <section id="services" className="services-section">
        {/* Line Separator */}
      <div className="services-content">
        <h2 className="services-headline">{t('services.headline')}</h2>
        <p className="services-subheadline">
          {t('services.subheadline')}
        </p>
        <div className="services-container">
          {servicesData.map((service) => (
            <Link
              key={service.title}
              to={service.buttonLink}
              className="service-card"
              style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none' }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              {service.subtitle && <p className="service-subtitle">{service.subtitle}</p>}
              <p className="service-description">{service.description}</p>
              <div className="service-button" style={{ marginTop: 'auto' }}>
                {service.buttonText}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;